<template src="./report-issue.html"/>

<script>
import { required, requiredIf, email, minLength, maxLength, numeric } from 'vuelidate/lib/validators'
import { validationMixin } from '@/mixins/validation'
import Vue from 'vue'
import { mask } from 'vue-the-mask'
import Moment from 'moment'

const validMobilePhone = (value) => {
  if (!value) return true
  return value.startsWith('6')
}

export default {
  mixins: [validationMixin],
  directives: { mask },
  data () {
    return {
      uniqueIdentificationNumberMask: '#############',
      identificationNumberMask: '#########',
      phoneNumberMask: '## ### ####',
      nameMask: {
        mask: 'CCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCC',
        tokens: {
          C: {
            pattern: /[a-zA-ZабвгдђежзијклљмнњопрстћуфхцчџшАБВГДЂЕЖЗИЈКЛЉМНЊОПРСТЋУФХЦЧЏШčćšđžČĆŠĐŽ\-\s]/
          }
        }
      },
      issue: {},
      userTypeSelectItems: [],
      userTypes: [
        {
          text: this.$t('issueUserTypes.' + 1),
          value: 1
        },
        {
          text: this.$t('issueUserTypes.' + 2),
          value: 2
        }
      ],
      selectedProblemTypes: [],
      problemTypes: {
        NoPaymentOnPensionAccount: 1,
        OnlyOnePaymentOnSharedAccount: 2,
        LivingAbroad: 3,
        WithrawMoneyOnBehalfOf: 4,
        NoPaymentOnRegisteredAccount: 5,
        ValidDocumentsDontMeetConditions: 6,
        OfficialBodyApprovedDocumentsDontMeetConditions: 7,
        Other: 8
      },
      userProblemTypes: {
        RetiredAndBeneficiary: {
          NoPaymentOnPensionAccount: 1,
          OnlyOnePaymentOnSharedAccount: 2,
          LivingAbroad: 3,
          WithrawMoneyOnBehalfOf: 4,
          Other: 8
        },
        Other: {
          NoPaymentOnRegisteredAccount: 5,
          WithrawMoneyOnBehalfOf: 4,
          ValidDocumentsDontMeetConditions: 6,
          OfficialBodyApprovedDocumentsDontMeetConditions: 7,
          Other: 8
        }
      },
      problemItems: [],
      loading: false,
      dialog: false,
      confirmationDialog: false,
      successDialog: false,
      errorText: '',
      errorDialog: false,
      reportIssueStartDate: Vue.$config.service_config[Vue.$config.service_name].reportIssueStartDate,
      reportIssueEndDate: Vue.$config.service_config[Vue.$config.service_name].reportIssueEndDate,
      showInstanceLink: Vue.$config.service_config[Vue.$config.service_name].showInstanceLink,
      instanceLink: Vue.$config.service_config[Vue.$config.service_name].instanceLink,
      headline: Vue.$config.service_config[Vue.$config.service_name].headline,
      subHeadline: Vue.$config.service_config[Vue.$config.service_name].subHeadline
    }
  },
  mounted () {
    this.setProblemTypes()
  },
  computed: {
    registrationEnabled () {
      const now = Moment()
      return now > Moment(this.reportIssueStartDate) && now < Moment(this.reportIssueEndDate)
    },
    nameErrors () {
      return this.getRetrieveValidationErrorsByName('name')
    },
    uniqueIdentificationNumberErrors () {
      return this.getRetrieveValidationErrorsByName('uniqueIdentificationNumber')
    },
    descriptionErrors () {
      return this.getRetrieveValidationErrorsByName('description')
    },
    emailErrors () {
      return this.getRetrieveValidationErrorsByName('email')
    },
    identificationNumberErrors () {
      return this.getRetrieveValidationErrorsByName('identificationNumber')
    },
    problemTypesErrors () {
      return this.getRetrieveValidationErrorsByName('problemType')
    },
    phoneNumberErrors () {
      return this.getRetrieveValidationErrorsByName('mobilePhoneNumber')
    },
    userTypeErrors () {
      return this.getRetrieveValidationErrorsByName('userType')
    },
    descriptionRequired () {
      return this.issue.problemType === this.problemTypes.Other
    }
  },
  methods: {
    clearRegisterModelData () {
      this.issue.mobilePhoneNumber = ''
      this.$v.$reset()
    },
    gotoInstance () {
      window.open(this.instanceLink + 'reklamacije', '_blank')
    },
    setProblemTypes () {
      this.selectedProblemTypes = this.userProblemTypes.NaturalPerson
      if (this.issue.userType === this.userTypes[0].value) {
        this.selectedProblemTypes = this.userProblemTypes.RetiredAndBeneficiary
      } else {
        this.selectedProblemTypes = this.userProblemTypes.Other
      }

      this.problemItems.length = 0
      for (const [, value] of Object.entries(this.selectedProblemTypes)) {
        this.problemItems.push({ text: this.$t('problemTypes.' + value), value: value })
      }
    },
    validateAndSubmitIssue () {
      this.$v.issue.$touch()
      if (this.$v.issue.$invalid) {
        this.$nextTick(function () {
          window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
          })
        })
        return
      }

      this.dialog = true
    },
    closeConfirmationDialog () {
      this.confirmationDialog = false
      this.$router.push('/')
    },
    submitIssue () {
      this.dialog = false
      this.loading = true

      if (this.issue.mobilePhoneNumber) {
        this.issue.phoneNumber = this.issue.mobilePhoneNumber.replace(/\s/g, '')
        this.issue.phoneNumber = '0' + this.issue.phoneNumber
      }

      if (!this.descriptionRequired) {
        this.issue.description = ''
      }

      this.$http.post(Vue.$apiConfig.insertIssuePost, this.issue)
        .then(response => {
          this.logConsole(response)
          this.clearRegisterModelData()
          this.loading = false
          this.confirmationDialog = true
          this.$refs.insertIssueForm.reset()
        },
        error => {
          this.logConsole(error)
          this.loading = false

          if (error.status === 400) {
            this.errorDialog = true
            this.errorText = this.$t('apiStatusCodes.' + error.data.status.code)
          } else {
            this.formatErrorResponse(error)
          }
        })
    },
    getRetrieveValidationErrorsByName (name) {
      if (!this.$v.issue[name].$dirty) return []
      return this.getValidationErrors('issue').filter((x) => { return x.field === name }).map(x => x.msg)
    }
  },
  validations () {
    const issueRules = {}

    Object.assign(issueRules, {
      name: {
        required,
        minLength: minLength(4),
        maxLength: maxLength(32)
      },
      uniqueIdentificationNumber: {
        required,
        numeric,
        minLength: minLength(13),
        maxLength: maxLength(13)
      },
      email: {
        email,
        maxLength: maxLength(128)
      },
      identificationNumber: {
        required,
        numeric,
        minLength: minLength(9),
        maxLength: maxLength(9)
      },
      problemType: {
        required
      },
      mobilePhoneNumber: {
        required,
        minLength: minLength(10),
        maxLength: maxLength(11),
        validMobilePhone
      },
      userType: {
        required
      },
      description: {
        required: requiredIf(function (name) {
          return this.descriptionRequired
        }),
        maxLength: maxLength(250)
      }
    })

    return {
      issue: issueRules
    }
  }
}
</script>

<style lang="scss">

  html {
    scroll-behavior: smooth;
  }

  .header-row {
    .treasury-logo {
      background-color: transparent;
    }
  }
  .header-image {
    vertical-align: middle;
    height: 30px;
  }
  .v-card__title.account-page-title {
    padding-top: 0;
  }
</style>

<style lang="scss" scoped>
h4 {
  margin-top: 20px;
  margin-bottom: 20px;
}

.blue-text {
  color: #1c558a;
}

.background-fill {
  background-image: linear-gradient(135deg, #c9233c 10%, #063f7b 100%);
}

  .second-header-part {
    background-image: linear-gradient(90deg, #19437b 40%, #0f2542 100%);
  }
.agreement-container {
  height: 120px;
  overflow-y: scroll;
  overflow-x:hidden;
}

.disabled-button {
  background-color:red !important;
}
</style>
